// extracted by mini-css-extract-plugin
export var navbarSubLink = "G_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "G_t1 d_f0 d_dB";
export var subPageLink = "G_gf d_gf";
export var burger = "G_vK";
export var sublinkSize = "G_vL";
export var linkSize = "G_vM";
export var Link = "G_sN w_sN w_r6 w_sr";